import {
  ElementRef,
  Injectable,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import { Router } from '@angular/router';
import { LoginAuthUserInputFields } from '@com-delta-idp/mnx-login-ui';
import { AnalyticsService } from '@com-delta-idp/mnx-utils';
import { FacadeService } from '../../data-access/login-modal/facade/facade.service';
import { ForgotLoginFacadeService } from '../../data-access/login-modal/facade/forgot-login-facade/forgot-login-facade.service';
import { ResetPasswordFacade } from '../../data-access/login-modal/facade/reset-password/reset-password.facade';
import { NextDisplayViewService } from '../../data-access/login-modal/services';
import { WifiPortalService } from '../../data-access/login-modal/services/wifi-portal/wifi-portal.service';
import { LoginModalHelperSuperSupportComponent } from './login-modal-helper-super-support.component';

@Injectable({
  providedIn: 'root'
})
export class LoginModalHelperSuperComponent extends LoginModalHelperSuperSupportComponent {
  innerWidth = 0;
  showBackDrop = false;
  lastNameField = false;

  constructor(
    public facade: FacadeService,
    protected renderer: Renderer2,
    protected elementRef: ElementRef,
    public nextDisplayViewService: NextDisplayViewService,
    public router: Router,
    public forgotLoginFacade: ForgotLoginFacadeService,
    public resetPasswordFacade: ResetPasswordFacade,
    protected wifiPortalService: WifiPortalService,
    protected analytics: AnalyticsService
  ) {
    super(
      facade,
      renderer,
      nextDisplayViewService,
      forgotLoginFacade,
      router,
      resetPasswordFacade,
      wifiPortalService,
      analytics
    );
  }

  setModalPositionHelper(loginModalNativeElement: ElementRef) {
    const alertAdvisoryContainer =
      document.querySelector('.alert-advisory-main-container')?.scrollHeight ??
      0;
    const heightNavContainer =
      document.querySelector('.navbar')?.scrollHeight ?? 0;
    let totalHeight = alertAdvisoryContainer + heightNavContainer;
    const loginModalEl = loginModalNativeElement;
    if (this.innerWidth <= 767) {
      totalHeight = 0;
      this.renderer.setStyle(loginModalEl, 'top', 0 + 'px');
    } else {
      this.renderer.setStyle(loginModalEl, 'top', totalHeight + 'px');
    }
    this.totalHeight = totalHeight;
  }

  toggleBackdropHelper() {
    const loginModalDiv = document.querySelector('.login-modal-container');
    if (loginModalDiv && loginModalDiv.classList.contains('d-none')) {
      this.showBackDrop = false;
    } else {
      this.showBackDrop = true;
    }
  }

  checkForWarmStateLoginInput(changes: SimpleChanges): boolean {
    return (
      changes &&
      changes.checkOutWarmState &&
      changes.checkOutWarmState.currentValue
    );
  }

  checkForDisplayLoginInput(changes: SimpleChanges): boolean {
    return (
      changes &&
      changes.displayLoginModal &&
      changes.displayLoginModal.currentValue
    );
  }

  handleTabKey(e: KeyboardEvent, modelId: string, tagsList: string) {
    if (e.key === 'Tab') {
      const focusable = this.elementRef.nativeElement
        .querySelector(modelId)
        .querySelectorAll(tagsList);
      if (focusable.length) {
        this.focusTab(focusable, e);
      }
    }
  }

  formAlertDisplay() {
    this.facade.formAlertDisplay();
  }

  fieldFocusChange(field: string) {
    this.facade.focusChange(field);
  }

  inputChange() {
    this.facade.formValueChange();
  }

  isLastNameEnabled(booleanValue: boolean) {
    this.lastNameField = booleanValue;
  }

  resetPasswordFormFieldFocusChange(field: string) {
    this.resetPasswordFacade.resetPasswordFormFocusChange(field);
  }

  resetPasswordFormInputChange(field: string) {
    this.resetPasswordFacade.resetPasswordFormValueChange(field);
  }

  onResetPasswordFormSubmit(): void {
    this.resetPasswordFacade.onResetPasswordFormSubmit(true);
  }

  onFormSubmit(userInputFields: LoginAuthUserInputFields): void {
    this.facade.onFormSubmit(true, userInputFields);
  }

  forgotLoginInputChange() {
    this.forgotLoginFacade.forgotLoginformValueChange();
  }

  closeOverLayMessage() {
    this.forgotLoginFacade.closeOverLayMessage();
  }

  forgotLoginFormSubmit(): void {
    this.forgotLoginFacade.onForgotLoginFormSubmit(true);
  }

  forgotLoginFieldFocusOut(field: string) {
    this.forgotLoginFacade.focusChangeForgotLogin(field);
  }
}
